import { BrowserRouter } from 'react-router-dom';

import { AppProviders } from '@/app/providers';
import { AppRoutes } from '@/app/router';

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </BrowserRouter>
  );
}
